<div  class="pointer-events-none w-full h-full relative flex flex-col justify-between" [class.hidden]="hideElement() || !showPanningButtonElements()">
<!-- <div [hidden]="!showPanningButtonElements()" class="pointer-events-none w-full h-full relative flex flex-col justify-between" [class.hidden]="hideElement"> -->

    <!-- UP BUTTON -->
    <div class="flex justify-center" [class]="neighborsVisible() ? 'pt-11 md:pt-10' : 'pt-0'">
        
        <app-button
            #upBtn
            [type]="type"
            [color]="color"
            class="transition-opacity pointer-events-auto"
        >

            <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
            </svg>
      
        </app-button>

    </div>

    <!-- LEFT & RIGHT BUTTONS -->
    <div class="flex justify-between">

        <!-- LEFT BUTTON -->
        <app-button
            #leftBtn
            [type]="type"
            [color]="color"
            class=" pointer-events-auto"
        >

            <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
            </svg>
            
        </app-button>

        <!-- RIGHT BUTTON -->
        <app-button
            #rightBtn
            [type]="type"
            [color]="color"
            class="pointer-events-auto"
        >   

            <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
  
        </app-button>

    </div>
    
    <!-- DOWN BUTTON -->
    <div class="flex justify-center mb-4 md:-mb-10">
         
        <!-- DOWN BUTTON -->
        <app-button
            #downBtn
            [type]="type"
            [color]="color"
            class="pointer-events-auto"
        >
            <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
        
        </app-button>

    </div>

</div>
